import React, { forwardRef, ForwardedRef } from 'react';

import Box from 'shared_DEPRECATED/components/Box/Box';
import Spacer from 'shared_DEPRECATED/components/Spacer/Spacer';

import { Typography } from 'shared/components/Typography';

const ChatMessageFailureState = forwardRef<HTMLDivElement, {}>(
  (props, ref: ForwardedRef<HTMLDivElement>) => {
    return (
      <React.Fragment>
        <Spacer size="sm zr" />
        <Box ref={ref}>
          <Typography textAlign="right" type="small" color="gray">
            Message is not sent. Tap to retry
          </Typography>
        </Box>
      </React.Fragment>
    );
  }
);

export default ChatMessageFailureState;
